import React from 'react';
import PropTypes from 'prop-types';
import { CheckCircle, Circle } from 'lucide-react';
import { lowerHere, upperHere, numberHere, specialHere } from 'utils/helper';
import './PasswordComplexityChecklist.scss';

const rules = [
  { label: 'Password must be at least 8 characters', check: (pwd) => pwd.length >= 8 },
  { label: 'Use a number', check: (pwd) => !!numberHere(pwd) },
  { label: 'Use a lowercase letter', check: (pwd) => !!lowerHere(pwd) },
  { label: 'Use an uppercase letter', check: (pwd) => !!upperHere(pwd) },
  { label: 'Use a special character', check: (pwd) => !!specialHere(pwd) },
  { label: 'Passwords match', check: (pwd, confirmPwd) => pwd.length > 0 && confirmPwd.length > 0 && pwd === confirmPwd },
];

const ChecklistItem = ({ label, isMet }) => (
  <div
    role="listitem"
    aria-label={`${label}: ${isMet ? 'met' : 'not met'}`}
    className={`checklist-item ${isMet ? 'checklist-item--met' : 'checklist-item--unmet'}`}
  >
    {isMet ? (
      <CheckCircle size={16} className="checklist-item__icon checklist-item__icon--met" />
    ) : (
      <Circle size={16} className="checklist-item__icon checklist-item__icon--unmet" />
    )}
    <span className="checklist-item__label">{label}</span>
  </div>
);

ChecklistItem.propTypes = {
  label: PropTypes.string.isRequired,
  isMet: PropTypes.bool.isRequired,
};

export const PasswordComplexityChecklist = ({ password, confirmPassword }) => (
  <div
    id="password-requirements"
    role="list"
    aria-label="Password requirements"
    aria-live="polite"
    className="password-complexity-checklist"
  >
    {rules.map((rule) => (
      <ChecklistItem
        key={rule.label}
        label={rule.label}
        isMet={rule.check(password, confirmPassword)}
      />
    ))}
  </div>
);

PasswordComplexityChecklist.propTypes = {
  password: PropTypes.string.isRequired,
  confirmPassword: PropTypes.string.isRequired,
};

export default PasswordComplexityChecklist;
